<template>
    <div class="pr-5">
        <editor-js
            :data="data.areas[0].content"
            @save="(d) => save(0, d)"
        />

        <div class="field-frame">
            <b-select expanded v-model="data.answer">
                <option v-for="opt in data.options" :value="opt.option">{{opt.option}}</option>
            </b-select>
            <b-switch class="mt-3" v-model="data.required">Response Required</b-switch>
        </div>

        <div class="select-options pl-5 ml-2">
            <hr/>
            <div class="columns" v-for="opt in data.options">
                <div class="column">
                    <b-input expanded v-model="opt.option"></b-input>

                </div>
                <div class="column is-narrow">
                    <b-button @click="removeOption(opt)" class="mr-2"><i class="far fa-trash-alt"></i></b-button>
                </div>
            </div>

            <hr/>
            <div class="mb-5">
                <b-button @click="addOption"><i class="fas fa-plus mr-2"></i>Add Select Option</b-button>
            </div>
        </div>

        <editor-js
            :data="data.areas[1].content"
            @save="(d) => save(1, d)"
        />

        <advanced-options :data="data"/>
    </div>
</template>

<script>
    import EditorJs from "../EditorJs.vue";
    import AdvancedOptions from "./AdvancedOptions.vue";
    import {v4 as uuidv4} from "uuid";

    export default {
        props: ['data'],
        components: {EditorJs, AdvancedOptions},
        data: function() {
            return {
                mediaTarget: null,
                mediaPicker: false,
                advanced: false
            };
        },
        methods: {
            addOption() {
                this.data.options.push({
                    option: ''
                });
            },
            removeOption(opt) {
                this.data.options.splice(this.data.options.indexOf(opt), 1);
            },
            save(area, data) {
                this.data.areas[area].content = data;
            }
        },
        created() {
            if (!this.data.options) {
                this.data.options = [];

                this.data.areas = [
                    {areas: 1, content: null, attributes: {}},
                    {areas: 2, content: null, attributes: {}},
                ];

                this.data.required = false;
                this.data.id = uuidv4();
            }
        }
    };
</script>

<style lang="scss">
    .flip-cards {
        margin: 0 1.3rem 0 1.3rem;

        .flip-card-editor {
            margin: 0.6rem 1rem 0 0;

        }

    }

</style>
